import type { Session } from "next-auth";

export const USER_MANAGER_GROUP_ID =
  "6f176035-d1c1-4228-bd5f-86166e6d8a00";

export function isUserManager(
  groups: readonly string[] | null | undefined,
): boolean {
  return groups?.includes(USER_MANAGER_GROUP_ID) ?? false;
}

export function sessionIsUserManager(session: Session | null): boolean {
  return isUserManager(session?.user.groups);
}
